import React, { useEffect, useMemo, useState } from 'react';
import { Select, Spin, message } from 'antd';
import axios from 'axios';
import AppMenu from '../components/AppMenu';
import OrgConfigurables from '../components/OrgConfigurables';
import './Configurables.css';

const { Option } = Select;

const Configurables = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrgId, setSelectedOrgId] = useState(localStorage.getItem('selectedOrg') || '');

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API}/api/organizations`);
      setOrganizations(response.data || []);
    } catch (error) {
      console.error('Error fetching organizations:', error);
      message.error('Failed to load organizations');
    } finally {
      setLoading(false);
    }
  };

  const orgOptions = useMemo(() => organizations.map((org) => ({
    value: org.id,
    label: org.name,
  })), [organizations]);

  const handleOrgChange = (value) => {
    setSelectedOrgId(value);
    localStorage.setItem('selectedOrg', value);
  };

  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '20px auto' }} />;
  }

  return (
    <div style={{ display: 'flex' }}>
      <AppMenu />
      <div className="configurables-page">
        <div className="configurables-header">
          <h1>Configurables</h1>
          <Select
            showSearch
            placeholder="Select organization"
            optionFilterProp="label"
            value={selectedOrgId || undefined}
            onChange={handleOrgChange}
            className="configurables-org-select"
          >
            {orgOptions.map((org) => (
              <Option key={org.value} value={org.value} label={org.label}>
                {org.label}
              </Option>
            ))}
          </Select>
        </div>

        {selectedOrgId ? (
          <OrgConfigurables orgId={selectedOrgId} />
        ) : (
          <div className="configurables-empty">Select an organization to view configurables.</div>
        )}
      </div>
    </div>
  );
};

export default Configurables;
